import { useEffect } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { About } from "@/components/site/About";
import { Gallery } from "@/components/site/Gallery";
import { Reviews } from "@/components/site/Reviews";
import { WhyUs } from "@/components/site/WhyUs";
import { Areas } from "@/components/site/Areas";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { CallFab } from "@/components/site/CallFab";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <div className="App overflow-x-clip">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <About />
        <Gallery />
        <Reviews />
        <WhyUs />
        <Areas />
        <Contact />
      </main>
      <Footer />
      <CallFab />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
